var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleColored = function SvgGoogleColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.9 10.879a9.46 9.46 0 0 0-.15-1.684H10v3.184h4.429a3.786 3.786 0 0 1-1.642 2.483v2.065h2.66c1.555-1.433 2.453-3.542 2.453-6.048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10 18.92c2.221 0 4.084-.736 5.446-1.993l-2.66-2.065c-.737.494-1.68.786-2.787.786-2.143 0-3.957-1.448-4.604-3.393h-2.75v2.132A8.226 8.226 0 0 0 10 18.921Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M5.395 12.254a4.947 4.947 0 0 1-.258-1.563c0-.543.094-1.07.258-1.564V6.995h-2.75a8.226 8.226 0 0 0-.874 3.696c0 1.328.317 2.584.875 3.695l2.75-2.132Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10 5.735c1.208 0 2.292.415 3.145 1.23l2.36-2.36C14.08 3.277 12.217 2.462 10 2.462c-3.216 0-6 1.844-7.353 4.533l2.749 2.133C6.043 7.182 7.857 5.735 10 5.735Z"
  })));
};
export default SvgGoogleColored;